import React, { useEffect } from "react";
import { useWSModal, WSList, WSLoader } from "@wingspanhq/fe-component-library";
import { ErrorAlert } from "@components/ErrorAlert";
import { queriesCards } from "@query";

type ActivateVirtualCardModalProps = {
  onClose: () => void;
  onSuccess: () => void;
  cardId: string;
};

const ActivateVirtualCardModal: React.FC<ActivateVirtualCardModalProps> = ({
  cardId,
  onClose,
  onSuccess
}) => {
  const [activateCard, activateCardMeta] =
    queriesCards.activateCard.useMutation();

  useEffect(() => {
    activateCard({ cardId }, { onSuccess });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cardId]);

  return (
    <WSList gap="L">
      {activateCardMeta.isError ? (
        <ErrorAlert error={activateCardMeta.error} context="BankCard" />
      ) : (
        <WSLoader.Spinner />
      )}
    </WSList>
  );
};

export const useActivateVirtualCardModal = () =>
  useWSModal(ActivateVirtualCardModal, {
    title: "Activate virtual card",
    size: "S"
  });
